import { Accept } from 'react-dropzone';

import { DEFAULT_ACCEPTED_MIME_TYPES } from '../constants/constants';

export const getListOfSupportedTypes = (acceptedFileTypes: Accept | undefined): string => {
  const supportedTypes: string[] = [];
  Object.entries(acceptedFileTypes || DEFAULT_ACCEPTED_MIME_TYPES).forEach(([_, value]) => {
    supportedTypes.push(
      value
        .map(type => type.replace('.', ''))
        .map(type => {
          return type.toUpperCase();
        })
        .join(', '),
    );
  });
  return supportedTypes.join(', ');
};
